import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../reducer/loginSlice';


export default function PortalPending() {
    const navigate = useNavigate();
    const dispatch: Dispatch = useDispatch();
    const userLoginData = useSelector((state: any) => state.data.login.value);

    const logOut = () => {
        dispatch(login([]));
        navigate('/api-access/login');
    };

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
            <div className="bg-white rounded-[10px] shadow-lg max-w-[500px] w-full p-10 text-center">
                <NavLink to='/'>
                    <img src="/images/Auth/logo.png" alt="hero" className="mx-auto mb-6" />
                </NavLink>

                <div className="bg-yellow-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#F29339" strokeWidth="2" />
                        <path d="M12 8V12" stroke="#F29339" strokeWidth="2" strokeLinecap="round" />
                        <circle cx="12" cy="16" r="1" fill="#F29339" />
                    </svg>
                </div>

                <h1 className="text-[28px] font-[700] text-[#42505C]">Application Under Review</h1>
                <p className="text-[14px] text-[#404040] mt-3 leading-[24px]">
                    Thank you for registering, <strong>{userLoginData?.data?.company_name || userLoginData?.name}</strong>.
                    Your API access application is currently being reviewed by our team.
                </p>
                <p className="text-[13px] text-[#808080] mt-4">
                    You'll receive an email notification once your application has been approved.
                    This usually takes 1-2 business days.
                </p>

                <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-3 mt-6 text-left">
                    <p className="text-[12px] text-blue-800">
                        <strong>What happens next?</strong>
                    </p>
                    <ul className="text-[12px] text-blue-700 mt-1 space-y-1 list-disc pl-4">
                        <li>Our team reviews your application</li>
                        <li>Once approved, you'll get an email with your API key</li>
                        <li>Log in again to access your full portal dashboard</li>
                    </ul>
                </div>

                <div className="mt-8 flex flex-col gap-3">
                    <button onClick={logOut} className="text-white bg-[#E04343] rounded-[30px] py-[10px] px-[42px] font-[700] text-[14px] w-full">
                        Sign Out
                    </button>
                    <NavLink to="/" className="text-[#E04343] text-[14px]">Return to Homepage</NavLink>
                </div>
            </div>
        </div>
    );
}